import { render, staticRenderFns } from "./cottageTable.vue?vue&type=template&id=471f2889&scoped=true"
import script from "./cottageTable.vue?vue&type=script&lang=js"
export * from "./cottageTable.vue?vue&type=script&lang=js"
import style0 from "./cottageTable.vue?vue&type=style&index=0&id=471f2889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471f2889",
  null
  
)

export default component.exports